// @vendors
import { Form } from "antd";
import { useContext, useEffect, useState } from "react";
import InputMask from "react-input-mask";
import Context from "../../../context/appContext";
import { getValueField } from "utils/utils";

export default function TextMaskField({ info, key, form, current }) {
  const validate = info.validate ? info.validate : {};
  const {
    dataForm: { data, formResponses, hiddenFields, disabledFields },
    setDataForm,
    checked,
  } = useContext(Context);
  const [message, setMessage] = useState({ help: "", status: "success" });
  const [isDescripcion, setIsDescripcion] = useState(false);
  const keysItems = {
    telefonoAAsegurado: false,
  };
  useEffect(() => {
    getDefaultValue();
    if (formResponses.findIndex((x) => x.key === info.key) === -1) {
      formResponses.push(info);
    }
  }, []);

  useEffect(() => {
    disabledFields[info.key] && getDefaultValue();
  }, [disabledFields[info.key]]);

  useEffect(() => {
    setIsDescripcion(false);
  }, [checked]);

  const onChange = (event) => {
    setIsDescripcion(false);
    const regex = new RegExp("[_ ]", "ig");
    let value = event.target.value.replace(regex, "");
    const pattern = validate && validate.pattern;
    if (
      value &&
      value.length === validate.maxLength &&
      (pattern ? RegExp(pattern).test(value) : true)
    ) {
      info.value = value;
      const index = formResponses.findIndex((x) => x.key === info.key);
      index != -1
        ? (formResponses[index].value = value)
        : formResponses.push(info);
      setMessage({ help: "", status: "success" });
    } else {
      setMessage({ help: validate.customMessage, status: "error" });
    }
    if (info.validate && info.validate.maxLength === value.length) {
      setTimeout(() => {
        setIsDescripcion(false);
      }, 2000);
      setIsDescripcion(true);
    }
  };

  const getDefaultValue = () => {
    const chkData = formResponses.find(
      (item) => item.key === "datosContratanteIgualAsegurado"
    );
    const hasCheckLoadLastStepInfo = current.newItems.find(
      (x) => x && x.key === "datosContratanteIgualAsegurado"
    );

    let value = "";
    if (
      info.customDefaultValue &&
      (!hasCheckLoadLastStepInfo ||
        (hasCheckLoadLastStepInfo && chkData && chkData.value))
    ) {
      const item = formResponses.find((x) =>
        x.key.includes(info.customDefaultValue)
      );
      value = item ? item.value : "";
      if (info.key==='telefonoCelularAsegurado') {
        const valueItem = getValueField('telefonoCelularAsegurado', formResponses);
        if (valueItem) {
          value = valueItem;
        }
      }
      disabledFields[info.key] = !keysItems[info.key]
        ? keysItems[info.key]
        : true;
      setDataForm({
        data,
        formResponses,
        hiddenFields,
        disabledFields: disabledFields,
      });
    } else if (info && info.value && info.value !== null && info.value !== "") {
      value = info.value;
    }

    if (value && value !== "") {
      form.setFieldsValue({ [info.key]: value });
      onChange({ target: { value: value } });
    }
  };

  return (
    <div 
    id={info.key}
    style={{
      position: "relative",
      display: hiddenFields[info.key] ? "none" : "block",
    }}
    >
      <Form.Item
        label={info.label}
        name={info.key}
        key={key}
        hidden={hiddenFields[info.key]}
        rules={[
          {
            required:
              hiddenFields[info.key] ||
              disabledFields[info.key] ||
              info.disabled
                ? false
                : validate.required,
            message: "Campo obligatorio",
          },
          {
            pattern: new RegExp(message.status === "error" ? "error" : ""),
            message: message.help,
          },
        ]}
      >
        <InputMask
          className="ant-input"
          mask={info.inputMask}
          placeholder={info.placeholder}
          disabled={disabledFields[info.key]}
          onChange={onChange}
        ></InputMask>
      </Form.Item>
      {info && info.description && isDescripcion && (
        <div className="ant-text-description">{`${info.description} ${info.validate.maxLength}`}</div>
      )}
    </div>
  );
}
